const isLite = Boolean(process.env.REACT_APP_LITE);

export enum Sdk {
  Jdbc = "jdbc",
  Python = "python",
  Dotnet = "dotnet",
  Go = "go",
  Node = "node",
}

export type SdkUrls = {
  cloud: {
    docsUrl: string;
    examplesUrl: string;
  };
  core: {
    docsUrl: string;
    examplesUrl: string;
  };
};

export const SDK_URLS: Record<Sdk, SdkUrls> = {
  [Sdk.Jdbc]: {
    cloud: {
      docsUrl:
        "https://docs.firebolt.io/guides/developing-with-firebolt/connecting-with-jdbc",
      examplesUrl: "",
    },
    core: {
      docsUrl:
        "https://docs.firebolt.io/firebolt-core/firebolt-core-connect/firebolt-core-connect-jdbc",
      examplesUrl: "",
    },
  },
  [Sdk.Python]: {
    cloud: {
      docsUrl:
        "https://docs.firebolt.io/guides/developing-with-firebolt/connecting-with-python",
      examplesUrl:
        "https://github.com/firebolt-db/firebolt-python-sdk/tree/main/examples",
    },
    core: {
      docsUrl:
        "https://docs.firebolt.io/firebolt-core/firebolt-core-connect/firebolt-core-connect-python",
      examplesUrl:
        "https://github.com/firebolt-db/firebolt-python-sdk/tree/main/examples",
    },
  },
  [Sdk.Dotnet]: {
    cloud: {
      docsUrl:
        "https://docs.firebolt.io/guides/developing-with-firebolt/connecting-with-net-sdk",
      examplesUrl:
        "https://github.com/firebolt-db/firebolt-net-sdk/tree/main#examples",
    },
    core: {
      docsUrl: "",
      examplesUrl:
        "https://github.com/firebolt-db/firebolt-net-sdk/tree/main#examples",
    },
  },
  [Sdk.Go]: {
    cloud: {
      docsUrl:
        "https://docs.firebolt.io/guides/developing-with-firebolt/connecting-with-go",
      examplesUrl:
        "https://github.com/firebolt-db/firebolt-go-sdk/tree/main#querying-example",
    },
    core: {
      docsUrl:
        "https://docs.firebolt.io/firebolt-core/firebolt-core-connect/firebolt-core-connect-go",
      examplesUrl:
        "https://github.com/firebolt-db/firebolt-go-sdk/tree/main#querying-example",
    },
  },
  [Sdk.Node]: {
    cloud: {
      docsUrl:
        "https://docs.firebolt.io/guides/developing-with-firebolt/connecting-with-nodejs",
      examplesUrl:
        "https://github.com/firebolt-db/firebolt-node-sdk/tree/main#example",
    },
    core: {
      docsUrl: "",
      examplesUrl:
        "https://github.com/firebolt-db/firebolt-node-sdk/tree/main#example",
    },
  },
};

export type SdkOption = {
  label: string;
  sdk: Sdk;
  docsUrl: string;
  examplesUrl: string;
};

const SDK_OPTIONS_CONFIG: Array<{ label: string; sdk: Sdk }> = [
  { label: "JDBC", sdk: Sdk.Jdbc },
  { label: "Python", sdk: Sdk.Python },
  { label: ".NET", sdk: Sdk.Dotnet },
  { label: "Go", sdk: Sdk.Go },
  { label: "Node.js", sdk: Sdk.Node },
];

export const SDK_OPTIONS: SdkOption[] = SDK_OPTIONS_CONFIG.map(config => {
  const urls = SDK_URLS[config.sdk];
  const modeUrls = isLite ? urls.core : urls.cloud;
  return {
    ...config,
    docsUrl: modeUrls.docsUrl,
    examplesUrl: modeUrls.examplesUrl,
  };
});
